import React from "react";
import { Menu, X } from "lucide-react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import "../style/navbar.css";

export default function Navbar() {
  const [open, setOpen] = React.useState(false);

  const links = [
    { label: "Homepage", path: "/" },
    { label: "Buy Crypto", path: "/buy-crypto" },
    { label: "News", path: "/news" },
    { label: "Blog", path: "/blog" },
    {label: "Security", path: "/security"}
  ];

  return (
    <nav>
      <div className="nav-wrapper">
        {/* Logo */}
       <NavLink
  to="/"
  className="heading flex items-center gap-2 no-underline text-white"
>
  <h1 className="text-xl font-semibold tracking-wide">
    VaultX Crypto
  </h1>
</NavLink>
        {/* Desktop Links */}
        <div className="nav-links desktop-only">
          {links.map((l, i) => (
            <NavLink
              key={i}
              to={l.path}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <button className="wallet-btn desktop-only">Wallet</button>

        {/* Mobile Menu Button */}
        <button className="mobile-only" onClick={() => setOpen(!open)}>
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {open && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="mobile-links"
        >
          {links.map((l, i) => (
            <NavLink
              key={i}
              to={l.path}
              onClick={() => setOpen(false)}
            >
              {l.label}
            </NavLink>
          ))}
          <div className="py-3 text-sm font-medium">Wallet</div>
        </motion.div>
      )}
    </nav>
  );
}
